var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 580,
    height: 167,
    viewBox: "0 0 580 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_2277_2820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M567.701 -15.9008L567.443 -16.2461C510.785 -29.5202 419.803 -28.0205 376.358 17.5139C376.358 17.5139 326.782 69.4775 293.643 61.9395C293.643 61.9395 321.097 88.254 358.019 53.1011C372.984 38.8413 407.026 -2.03119 433.145 3.54486C432.457 3.5505 416.147 21.8319 400.669 51.6297C390.69 70.8459 410.679 89.3086 426.818 79.7559C437.665 73.3464 438.979 54.2426 440.205 43.163C442.454 22.7055 446.592 5.49092 468.079 -2.15602C498.465 -12.9642 518.491 -13.6534 567.701 -15.9008Z",
    fill: "url(#paint0_linear_2277_2820)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M199.095 -17.1913C188.537 -20.0542 179.958 -27.6835 172.944 -35.6128C167.944 -41.2667 159.995 -53.0809 151.334 -46.4594C136.968 -35.4684 166.284 -23.2076 161.145 -14.0568C155.888 -4.67437 133.212 -23.1637 128.322 -26.2844C113.121 -35.8601 98.6599 -43.9071 80.5966 -45.3304C61.7793 -46.8324 34.1512 -44.0724 24.1168 -25.0008C20.5551 -18.2314 20.5895 -9.97092 20.6376 -2.75173C46.2983 -20.4674 79.4457 -20.0932 108.77 -11.7194C142.186 -2.12845 173.872 22.8218 206.973 -1.93888L226.238 -18.3926C216.736 -18.1744 208.872 -14.5686 199.095 -17.1913Z",
    fill: "url(#paint1_linear_2277_2820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.106 0.456316C134.362 -5.87446 120.071 -9.02218 105.217 -11.3857C79.8915 -15.422 57.5755 -15.8512 32.4317 -10.5307C3.75267 -4.53589 -25.7718 3.408 -50.4595 19.6928C-67.6717 31.0552 -105.788 61.3241 -92.8634 74.3653C-82.0649 78.7785 -71.8189 63.6297 -63.2907 57.7536C-51.8406 49.8733 -38.97 42.3873 -26.0367 37.2967C-36.3157 41.3315 -48.9848 53.8335 -57.2638 61.1776C-66.1414 69.0335 -83.3341 81.2787 -76.5222 91.8681C-65.4724 109.051 -36.2084 76.2185 -30.9752 70.8207C-15.6675 54.9978 5.38407 38.005 26.7421 31.1551C37.0883 27.8362 46.7992 25.0393 57.3065 25.5652C23.6045 36.2513 -6.68486 60.8811 -11.7282 103.835C-13.0435 114.929 -3.79479 133.989 10.7928 131.572C29.4394 128.48 31.2135 91.7907 38.1861 78.0326C48.6182 57.4384 67.022 39.6431 89.9706 33.9775C122.019 26.0649 152.105 43.1291 182.119 51.4228C208.848 58.8045 236.573 64.8504 264.14 67.9132C273.758 68.9795 288.036 71.7418 297.108 66.7548L206.573 28.1553C186.187 23.6171 166.887 9.14653 148.106 0.456316Z",
    fill: "url(#paint2_linear_2277_2820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.383 22.224C50.3122 -39.9023 -9.37601 10.7933 -9.37601 10.7933C28.2969 -3.71979 60.1702 -25.9239 154.904 24.3846C273.531 87.387 302.642 65.3771 302.642 65.3771C274.84 58.4749 282.469 84.3566 166.383 22.224Z",
    fill: "#035D7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.959 -23.1891C246.235 -40.4059 174.329 -8.13102 165.976 -4.25914C173.65 -7.79168 234.707 -34.7195 291.349 -19.2002C291.349 -19.2002 335.366 1.52102 411.464 -48.5594L416.499 -54.2251C416.499 -54.2251 342.636 -4.88741 292.959 -23.1891Z",
    fill: "url(#paint3_linear_2277_2820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-31.6957 25.791C-31.6957 25.791 54.1405 -40.969 160.081 21.3842C253.839 76.5716 298.598 67.4859 298.598 67.4859C298.598 67.4859 225.375 50.2492 165.952 2.07397C165.952 2.07397 74.916 -64.1017 -31.6957 25.791Z",
    fill: "url(#paint4_linear_2277_2820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.023 -21.2159C327.185 -9.16219 296.751 -20.2415 266.422 -23.3107C230.678 -26.9655 193.205 -19.0506 161.294 -2.78841C161.294 -2.78841 233.384 71.1905 293.643 61.9392C354.495 52.6001 384.295 -1.79876 411.464 -51.4356C393.529 -40.7487 376.693 -29.1537 357.023 -21.2159Z",
    fill: "url(#paint5_linear_2277_2820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.104 21.4228C373.104 21.4228 433.253 -38.8549 569.752 -13.2263L554.574 -33.0432C541.196 -34.9646 417.23 -50.6668 373.104 21.4228Z",
    fill: "#035D7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.958 -99.0635L499.243 -105.221C491.701 -107.145 452.961 -110.841 385.413 -13.9471C305.859 100.216 262.488 53.5959 169.064 -1.2147C87.2495 -49.2191 7.19088 -12.8937 -35.8217 28.9308C-35.8217 28.9308 69.5363 -60.4023 168.233 8.72146C265.4 76.7754 324.964 100.642 388.173 -3.00239C388.173 -3.00239 444.642 -108.153 503.958 -99.0635Z",
    fill: "#9FE2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.176 21.2834C374.487 18.7356 395.126 -19.4865 469.831 -23.7735C524.416 -26.9038 560.226 -18.2455 567.386 -16.316L504.037 -99.0028C437.043 -105.021 375.469 16.717 373.176 21.2834Z",
    fill: "url(#paint6_linear_2277_2820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.104 21.4225L402.504 -6.3747C450.252 -90.343 509.118 -82.1937 518.377 -80.3135L503.995 -99.0592C435.134 -108.314 373.104 21.4225 373.104 21.4225Z",
    fill: "#0086B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.74 80.4803C375.65 94.1174 393.357 42.4887 398.895 30.4033C394.151 40.7514 332.507 63.0185 356.74 80.4803Z",
    fill: "url(#paint7_linear_2277_2820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.083 39.3233C286.683 36.7072 283.167 31.9109 273.328 27.1081C166.971 -24.7669 296.474 12.3551 294.548 -5.21915C292.784 -21.282 252.055 -19.2079 240.998 -18.3487C177.641 -13.2925 182.146 -2.53467 182.146 -2.52727C184.346 7.71522 221.926 25.555 243.466 36.1616C257.315 42.9975 288.286 47.179 287.083 39.3233Z",
    fill: "url(#paint8_linear_2277_2820)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M208.304 -7.80284L208.301 -7.8398C197.604 -12.0895 193.026 -1.82039 199.751 6.65759C215.817 26.9522 226.909 -0.281331 208.304 -7.80284Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.835 -14.0282C346.132 -14.0355 344.431 -14.1346 342.74 -14.325C332.937 -15.3482 321.073 -18.1604 314.571 -9.74225C308.281 -1.60705 316.736 8.63206 324.933 11.2437C332.93 13.7734 341.465 12.1844 348.526 7.94607C364.01 -1.35814 373.837 -13.4297 385.162 -30.2103C378.352 -20.068 359.331 -14.1021 347.835 -14.0282Z",
    fill: "url(#paint9_linear_2277_2820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.263 -17.597C366.949 -15.3339 361.628 -14.2024 357.762 -13.14C348.71 -10.6511 341.013 -12.7643 331.933 -13.3201C329.659 -13.4494 327.38 -13.2127 325.182 -12.6192C322.891 -12.0694 320.791 -10.9176 319.102 -9.28479C315.445 -5.45851 317.356 0.621561 321.951 2.88686C325.677 4.72518 330.558 4.44318 334.534 3.65508C343.533 1.86867 351.658 -2.65539 358.948 -8.06958C361.333 -9.8413 363.636 -11.7111 365.906 -13.623C367.407 -14.8992 368.624 -16.4742 370.263 -17.597Z",
    fill: "url(#paint10_linear_2277_2820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.768 6.94456C325.715 12.6208 317.29 4.53444 313.879 -0.165429C319.084 13.1271 333.833 11.5823 333.833 11.5823C354.978 10.8412 379.015 -21.9518 379.015 -21.9518C379.015 -21.9518 361.268 -0.786419 340.768 6.94456Z",
    fill: "url(#paint11_linear_2277_2820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.968 20.6009C343.691 19.0073 341.679 18.5003 339.592 18.7122C334.295 19.2474 328.581 24.4054 333.54 28.0709C338.27 31.4632 349.2 25.8873 344.968 20.6009Z",
    fill: "url(#paint12_linear_2277_2820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.877 19.449C337.69 19.4155 332.127 22.0359 334.978 24.8001C338.705 28.4068 347.099 19.5608 339.877 19.449Z",
    fill: "url(#paint13_linear_2277_2820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.698 26.1779C339.367 32.037 344.275 24.3371 344.275 24.3371C337.363 29.9021 332.698 26.1779 332.698 26.1779Z",
    fill: "url(#paint14_linear_2277_2820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.162 -2.43996C305.86 -3.22493 305.36 -3.91962 304.71 -4.45763C304.061 -4.99564 303.283 -5.35896 302.451 -5.51286C298.081 -6.63543 292.01 -4.20082 294.894 0.14371C297.616 4.21769 307.967 3.0088 306.162 -2.43996Z",
    fill: "url(#paint15_linear_2277_2820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.455 -4.84481C300.729 -5.51397 295.53 -5.08241 296.981 -2.0228C298.871 1.93356 308.205 -2.64156 302.455 -4.84481Z",
    fill: "url(#paint16_linear_2277_2820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.753 -1.58496C298.312 5.03612 304.502 0.34127 304.502 0.34127C297.374 2.74902 294.753 -1.58496 294.753 -1.58496Z",
    fill: "url(#paint17_linear_2277_2820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.373 18.6874C96.2112 -48.5439 18.5908 -2.90738 18.5908 -2.90738C95.944 -42.7729 180.708 22.5602 180.708 22.5602C268.85 78.8264 295.634 66.0371 295.634 66.0371C253.427 70.9314 183.373 18.6874 183.373 18.6874Z",
    fill: "#EDFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9053 24.7722C15.6745 27.0346 12.7293 29.6746 10.133 32.6353C-1.03418 45.518 8.70937 53.419 22.9932 46.3276C37.277 39.2362 47.6313 27.9287 62.1933 20.9582C92.3952 6.50748 119.424 16.3492 122.173 18.4372C97.6297 -0.205657 45.3661 5.92064 18.9053 24.7722Z",
    fill: "url(#paint18_linear_2277_2820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.07 17.0253C30.207 19.8819 22.7712 23.6051 17.6434 29.114C8.06551 39.4732 14.8482 44.1276 24.8106 38.3177C37.9315 30.6722 47.8314 20.6238 62.427 15.137C69.7085 12.3762 75.4726 11.688 83.7678 11.127L84.5047 9.63904C68.9747 7.8599 51.405 11.0448 37.07 17.0253Z",
    fill: "url(#paint19_linear_2277_2820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27.6066 31.9863C-32.5408 36.151 -38.5503 47.5204 -33.1058 53.3201C-26.5445 60.2719 -17.4967 50.4419 -13.176 45.8686C-11.4393 44.0328 -9.56555 42.0234 -7.56376 39.923C5.90326 25.7429 24.8631 7.26058 43.899 6.83692C25.9783 2.95849 -14.2641 20.7132 -27.6066 31.9863Z",
    fill: "url(#paint20_linear_2277_2820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20.2365 47.9672C0.228495 18.4295 17.8758 13.2326 27.6308 8.88686L19.6236 11.2399C9.47635 14.2099 -1.22866 19.1749 -10.4314 24.3201C-17.355 28.1916 -30.3913 34.8427 -33.1249 42.8074C-34.3154 46.2827 -32.8118 53.247 -28.4686 53.3907C-26.5405 53.458 -24.6048 52.1946 -22.9586 50.7592C-21.952 49.9293 -21.0392 48.9931 -20.2365 47.9672Z",
    fill: "url(#paint21_linear_2277_2820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.13939 68.4821C-4.26961 64.0331 -5.10718 59.4278 -4.76813 55.2567C-4.24598 48.7761 -1.15733 43.2153 0.308423 37.0522C-10.6307 44.858 -24.1453 60.8473 -20.2519 75.432C-18.6606 81.3422 -10.3878 85.702 -6.32844 78.9855C-4.39798 75.8054 -4.03336 72.1897 -4.13939 68.4821Z",
    fill: "url(#paint22_linear_2277_2820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5453 34.0277C58.5453 34.0277 98.4261 5.27214 199.248 50.5069C199.25 50.5365 94.7562 -8.71215 58.5453 34.0277Z",
    fill: "#EDFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5448 75.0113C68.1639 87.8816 81.0321 90.509 90.9859 84.1721C97.1496 80.2446 101.379 72.78 107.792 69.0943C147.947 46.0331 192.846 65.1145 214.116 64.4312C214.116 64.4312 89.1664 26.241 72.5448 75.0113Z",
    fill: "url(#paint23_linear_2277_2820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0397 107.71C45.8923 108.56 45.7369 109.404 45.5665 110.249C46.3589 109.314 47.0572 108.527 47.6042 107.923L46.0397 107.71Z",
    fill: "url(#paint24_linear_2277_2820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4762 136.325C40.7395 124.593 45.2156 113.232 47.5227 101.783C38.3892 112.489 15.5345 142.915 29.9885 154.759C35.785 159.538 42.3851 157.488 44.3443 150.91C45.4554 147.165 41.7611 140.227 41.4762 136.325Z",
    fill: "url(#paint25_linear_2277_2820)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2277_2820",
    x1: 260.471,
    y1: 44.0788,
    x2: 534.58,
    y2: 23.2693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#EFF8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E5F4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D5EDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BEE3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A1D7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98D3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2277_2820",
    x1: 25.8837,
    y1: -6.43398,
    x2: 224.637,
    y2: -31.4265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20BEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#1DB7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#139CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0B89CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#077DC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001CBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2277_2820",
    x1: -139.676,
    y1: 71.9373,
    x2: 243.458,
    y2: 42.8489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#EFF8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E5F4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D5EDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BEE3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A1D7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98D3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2277_2820",
    x1: 172.331,
    y1: -9.83948,
    x2: 418.196,
    y2: -40.7606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20BEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#1DB7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#139CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0B89CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#077DC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001CBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2277_2820",
    x1: 199.346,
    y1: -27.052,
    x2: 24.7721,
    y2: 171.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20BEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#1EBAE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#1DB7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#139CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#0B89CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#067DC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001CBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2277_2820",
    x1: 172.18,
    y1: 27.8129,
    x2: 417.561,
    y2: -3.04037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20BEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#1EBAE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#1DB7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#139CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#0B89CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#067DC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001CBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2277_2820",
    x1: 371.997,
    y1: -31.1829,
    x2: 563.773,
    y2: -55.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20BEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#1DB7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#139CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0B89CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#077DC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001CBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2277_2820",
    x1: 400.722,
    y1: 29.5496,
    x2: 339.572,
    y2: 98.9248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#EFF8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E5F4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#D5EDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6E6F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2277_2820",
    x1: 162.948,
    y1: -8.55532,
    x2: 293.022,
    y2: 17.4249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2277_2820",
    x1: 314.058,
    y1: 3.51654,
    x2: 400.809,
    y2: -22.9656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B88CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#0F91D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#19ACDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#21C1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#27D0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2AD8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2BDBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#28D4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#21C1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#15A2DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001CBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2277_2820",
    x1: 328.804,
    y1: 11.5942,
    x2: 357.963,
    y2: -35.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2277_2820",
    x1: 380.326,
    y1: -11.6915,
    x2: 321.195,
    y2: 5.42847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2277_2820",
    x1: 345.615,
    y1: 19.8322,
    x2: 332.431,
    y2: 27.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BDBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2AD8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#26CEF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#20BEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#17A7DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0C8ACD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001CBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2277_2820",
    x1: 336.808,
    y1: 20.0939,
    x2: 340.226,
    y2: 24.6138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2277_2820",
    x1: 336.806,
    y1: 23.0661,
    x2: 340.474,
    y2: 27.9178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2277_2820",
    x1: 305.67,
    y1: -4.82268,
    x2: 295.309,
    y2: 1.46735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BDBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2AD8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#26CEF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#20BEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#17A7DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0C8ACD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001CBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2277_2820",
    x1: 298.679,
    y1: -5.25366,
    x2: 302.123,
    y2: -0.698186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2277_2820",
    x1: 297.32,
    y1: -3.53705,
    x2: 301.79,
    y2: 2.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2277_2820",
    x1: 7.25565,
    y1: 32.6109,
    x2: 122.147,
    y2: 18.1715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20BEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#37C4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#62D0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#85DAF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#A1E2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#B4E8F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C0EBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4ECF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2277_2820",
    x1: 28.262,
    y1: 55.263,
    x2: 71.0018,
    y2: -13.5664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2277_2820",
    x1: -34.4928,
    y1: 35.8344,
    x2: 46.259,
    y2: 25.6806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20BEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#37C4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#62D0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#85DAF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#A1E2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#B4E8F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C0EBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4ECF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2277_2820",
    x1: -26.0681,
    y1: 62.5163,
    x2: 20.0842,
    y2: -11.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2277_2820",
    x1: -14.4193,
    y1: 76.0905,
    x2: -3.41702,
    y2: 39.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20BEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#37C4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#62D0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#85DAF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#A1E2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#B4E8F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C0EBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4ECF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2277_2820",
    x1: 54.8034,
    y1: 72.3438,
    x2: 194.941,
    y2: 61.7022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#EFF8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E5F4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D5EDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BEE3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A1D7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98D3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2277_2820",
    x1: 46.3508,
    y1: 111.861,
    x2: 40.076,
    y2: 187.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#EFF8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E5F4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D5EDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BEE3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A1D7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98D3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2277_2820",
    x1: 38.6368,
    y1: 102.601,
    x2: 32.3634,
    y2: 178.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#EFF8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E5F4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D5EDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BEE3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#A1D7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98D3F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2277_2820"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 669.391,
    height: 229.372,
    fill: "white",
    transform: "translate(-105 -62.2627) rotate(-4.17529)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop);
export default __webpack_public_path__ + "static/media/top.6e9e0bcd8264d05988062a69919b16e8.svg";
export { ForwardRef as ReactComponent };